import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/scss/main.scss';

const swUrl = `${window.location.origin}/service-worker.js`;

if ('serviceWorker' in navigator) {
    navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
            console.log('Service Worker registrado com sucesso:', registration);
        })
        .catch((error) => {
            console.error('Falha ao registrar o Service Worker:', error);
        });
} else {
    console.warn('Service Workers não são suportados neste navegador.');
}

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
